export default "__VITE_ASSET__DSUYVOmL__"